import PropTypes from "prop-types";
import { useContext, useEffect, useState } from "react";
import { NavContext } from "@/core/providers/NavProvider";
import { css } from "@emotion/react";
import { Link } from "react-router-dom";


const NavImageTile = ({ slug, size, onClick }) => {

    const { menuComponents } = useContext(NavContext);
    const [tileContent, setTileContent] = useState();

    useEffect(() => {
        if (menuComponents[slug]) setTileContent(menuComponents[slug])
    }, [menuComponents, slug])

    const colImg = css(`
        position: absolute;
        width: 100%;
        height: 100%;
        object-fit: cover;
    `);

    const copyCss = css(`
        position: absolute;
        bottom: 20px;
        left: 20px;
        color: #fff;
        font-size: 24px;
        font-weight: 400;
        z-index: 1;
        text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.9);
    `)

    const tileCss = css(`
        display: block;
        height: 0;
        overflow: hidden;
        padding-bottom: 56.2%;
        position: relative;
    `)

    const shadow = {
        position: "absolute",
        left: "0",
        top: "0",
        display: ["none", "block"],
        width: "100%",
        height: "100%",
        backgroundImage: "linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0, 1%) 33%)",
    }

    const textCss = css(`
        display: block;
        margin-top: 10px;
    `)

    const linkCss = css(`
        text-decoration: none;
        &:hover {
            text-decoration: underline;
        }
    `)

    return tileContent?.link ? (
        <Link css={linkCss} className={`size-1of${size} pl-4`} to={tileContent.link.link_url} onClick={onClick}>
            <div css={tileCss} className={'mx-4 mx-md-0'}>
                <img css={colImg} src={tileContent.image.image_url} alt={tileContent.image.alt_text} loading="lazy" />
                <span css={shadow} />
                <span css={copyCss}>{tileContent.description}</span>
            </div>
            <div css={textCss} className={'mx-4 mx-md-0'} >{tileContent.link.link_text}</div>
        </Link>
    ) : <></>;
};

NavImageTile.propTypes = {
    slug: PropTypes.string,
    size: PropTypes.number,
    onClick: PropTypes.func
}

export default NavImageTile;
